import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap'; // jeśli chcesz LightButton — też łatwo zmienimy

const GoBackButton = ({
                        label,
                        className = "",
                        variant = "secondary", // domyślnie szary
                      }) => {
  const navigate = useNavigate();

  return (
    <Button
      size={"sm"}
      variant={variant}
      className={className}
      onClick={() => navigate(-1)}
    >
      {label}
    </Button>
  );
};

export default GoBackButton;
